import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Sidebar from "./Sidebar";
import routes from "../routes";
import iconSet from "../selection.json";
import IcomoonReact, { iconList } from "icomoon-react";

const props = {
 margin:'0 auto',
}
function Footer() {
  const [isHovering1, setIsHovering1] = useState(false);
  const [isHovering2, setIsHovering2] = useState(false);
  const [isHovering3, setIsHovering3] = useState(false);
  const [isHovering4, setIsHovering4] = useState(false);


  // const handleMouseEnter = () => {
  //   setIsHovering(true);
  // };

  // const handleMouseLeave = () => {
  //   setIsHovering(false);
  // };
  
  return (
    <div>
       <footer>
        <div id="footers">
          <div
            id="Rgc-Footer-Mobile"
            className="rgc-mobile-footer"
          >
            <Row className="justify-content-center rgc-mobile-content">
              <Col xs={4}>
                <NavLink to="dashboard">
                  <div className="d-flex flex-column rgc-footer-item">
                    {/* <i class="fas fa-home"></i> */}
                    <div>
                    <IcomoonReact
                     {...props} 
                     className="rgc-ico"
                      iconSet={iconSet}
                      color= {isHovering1 ? '#E78E09' : '#444'}
                      size={30}
                      icon="home-2"
                      onMouseEnter={() => setIsHovering1(true)}
                      onMouseLeave={() => setIsHovering1(false)}
                      />   
                      </div>
                    <span>داشبورد</span>
                  </div>
                </NavLink>
              </Col>

              <Col xs={4}>          
                <NavLink to="orders">
                <div className="d-flex flex-column rgc-footer-item">
                  {/* <i class="fa fa-clipboard-list"></i> */}
                  <div>
                  <IcomoonReact
                     className="rgc-ico"
                      iconSet={iconSet}
                      color= {isHovering2 ? '#E78E09' : '#444'}
                      size={30}
                      icon="task-square"
                      onMouseEnter={() => setIsHovering2(true)}
                      onMouseLeave={() => setIsHovering2(false)}
                      />
                    </div>
                  <span>تمامی سفارشات</span>
                </div>
                </NavLink>           
              </Col>
              

              <Col xs={4}>
                <NavLink to="report">
                <div className="d-flex flex-column rgc-footer-item">
                    {/* <i class="fa fa-trophy"></i> */} 
                    <i class="fa-solid fa-list-ul mb-1"></i>      
                    <span>گزارش </span>
                </div>
                </NavLink>
              </Col>
    
            </Row>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
